<template>
  <div class="dni-upload" :class="className" @click="cancelFile">
    <el-button type="primary" class="left-btn">
      <i class="el-icon-upload"></i>
      <span class="upload-font">{{ $t(buttonStr) }}</span>
    </el-button>
    <input
      :id="displayId"
      type="text"
      v-model="upload_file_name"
      :placeholder="$t(placeholder)"
      name="restore_file_select"
      unselectable="on"
      :disabled="disabled"
    />
    <el-button
      type="primary"
      class="right-btn"
      :style="{ background: buttonColor, 'border-color': buttonColor }"
      :disabled="disabled"
    >
      <i class="el-icon-upload"></i>
      <span class="upload-font">{{ $t(buttonStr) }}</span>
    </el-button>
    <input
      type="file"
      :ref="fileId"
      :accept="accept"
      multiple=""
      name="mtenRestore"
      unselectable="on"
      @change="change"
      :id="fileId"
      :disabled="disabled"
    />
  </div>
</template>
<script>
import { logWithPrefix } from "@/plugins/logging";
const log = logWithPrefix("[components/elements/dniUpload.vue]");
export default {
  props: {
    className: {
      type: String, // normal, wizard
      default: "normal",
    },
    fileId: {
      type: String,
      default: "file",
    },
    displayId: {
      type: String,
      default: "text",
    },
    accept: {
      type: String,
      default: "cfg", // *.img
    },
    maxSize: {
      type: String,
      default: "100M",
    },
    emptyMsg: {
      type: String,
      default: "filename_null",
    },
    overSizeMsg: {
      type: String,
      default: "select_correct_config_file",
    },
    errorMsg: {
      type: String,
      default: "not_correct_file",
    },
    id: {
      type: String,
      default: "file_upg",
    },
    buttonStr: {
      type: String,
      default: "browse_mark",
    },
    placeholder: {
      type: String,
      default: "",
    },
    buttonColor: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    checkFunc: Function, //self defined checkFunc should return error msg, if pass return "".
  },
  data() {
    return {
      upload_file_name: "",
    };
  },
  methods: {
    checkFileFormat(name) {
      if (this.accept.length == 0) return true;
      let accept = this.accept;
      if (accept == ".txt") {
        accept = "txt";
      }
      if (accept == "image/*") {
        accept = "(jpg|JPG|jpeg|JPEG|gif|GIF|png|PNG)";
      }
      var reg = new RegExp(`^((.*)\\.${accept})$`);
      if (!reg.test(name)) {
        if (this.errorMsg === "not_correct_file") {
          this.utils.alertBox(this.$t("not_correct_file") + this.accept);
        } else {
          this.utils.alertBox(this.$t(this.errorMsg));
        }
        return false;
      }
      return true;
    },
    checkFormatAndSize(obj) {
      // Check format
      const name = obj.name.substr(obj.name.lastIndexOf("\\") + 1);
      if (!this.checkFileFormat(name)) {
        return false;
      }
      if (!obj.size || !this.utils.checkFileSize(this.maxSize, obj.size)) {
        if (this.overSizeMsg == "file_size_up") {
          this.utils.alertBox(this.$t(this.overSizeMsg) + " " + this.maxSize + ".");
        } else {
          this.utils.alertBox(this.$t(this.overSizeMsg));
        }
        return false;
      }
      return true;
    },
    change() {
      const obj = this.$refs[this.fileId].files[0];
      log("dniUpload", obj);
      const name = obj.name.substr(obj.name.lastIndexOf("\\") + 1);
      if (!this.checkFormatAndSize(obj)) {
        this.cancelFile();
        return;
      }
      this.upload_file_name = name;
    },
    checkFile() {
      if (this.upload_file_name == "" && this.emptyMsg != "") {
        this.utils.alertBox(this.$t(this.emptyMsg));
        return false;
      }
      const obj = this.$refs[this.fileId].files[0];
      if (!this.checkFormatAndSize(obj)) {
        this.cancelFile();
        return false;
      }
      if (typeof this.checkFunc == "function") {
        const ret = this.checkFunc(this.upload_file_name);
        if (ret.length > 0) {
          this.utils.alertBox(ret);
          this.cancelFile();
          return false;
        }
      }
      return true;
    },
    getFileText() {
      return this.upload_file_name;
    },
    getFile() {
      console.log(this.$refs[this.fileId].files[0]);
      return this.$refs[this.fileId].files[0];
    },
    cancelFile() {
      log("cancelFile", this.$refs[this.fileId].value);
      this.$refs[this.fileId].value = "";
      this.upload_file_name = "";
      log("cancelFile", this.$refs[this.fileId].files[0]);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@/styles/variables.scss";
.dni-upload {
  height: 40px;
  position: relative;
  display: flex;
  cursor: pointer;
  .el-button.left-btn,
  i {
    display: none;
  }
  .el-button {
    height: 30px;
    line-height: 30px;
    min-width: unset;
    padding: 0 30px;
    text-transform: uppercase;
    margin-left: 10px;
    margin-top: 0 !important;
  }
  input[type="file"] {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    width: 100%;
    margin: 0;
    padding: 0;
    font-size: 100px;
    cursor: pointer;
    opacity: 0;
  }
  input[type="text"] {
    max-width: 500px;
    width: 100%;
    border-bottom: $formInputBorderBottom;
    border-top: $formInputBorderTop;
    border-left: $formInputBorderLeft;
    border-right: $formInputBorderRight;
    font-size: $formInputFontSize;
    height: 20px;
  }
  .el-icon-upload {
    font-size: 30px;
    position: absolute;
    left: 30px;
    top: 6px;
  }
}
.dni-upload:hover {
  .el-button {
    opacity: 0.8;
  }
}
.dni-upload.wizard {
  display: flex;
  height: 45px;
  i {
    display: inline-block;
  }
  .el-button.left-btn {
    display: inline-block;
  }
  .el-button.right-btn {
    display: none;
  }
  .el-button {
    height: 45px;
    line-height: 45px;
    padding-left: 60px;
    margin-right: 10px;
  }
}
.smb-gui {
  .dni-upload.wizard {
    width: 60%;
    margin: 20px 20%;
    .el-button.left-btn {
      display: none;
    }
    .el-button.right-btn {
      display: inline-block;
      i {
        display: none;
      }
    }
    .el-button {
      height: 45px;
      line-height: 45px;
      padding: 0;
      margin: 0;
      border: none;
      background-color: #fff;
      color: $wizardDefaultButtonFontColor;
      width: 40%;
    }
    input[type="text"] {
      width: 60%;
      height: 45px;
      line-height: 45px;
      border: none;
      border-bottom: $formInputBorderBottom;
    }
  }
}
.dni-upload.gp {
  .el-button {
    height: 22px;
    background: #702b86;
    border-color: #702b86;
    line-height: 22px;
    border-radius: $formInputBorderRadius;
    text-transform: none;
    font-size: 14px;
    font-weight: bold;
  }
  input[type="text"] {
    border-radius: $formInputBorderRadius;
  }
}
.dni-upload.restore-upload {
  input[type="text"] {
    border-radius: $formInputBorderRadius;
    margin-top: 4px;
  }
}
.el-button.el-button--primary:hover,
.el-button.el-button--primary:disabled {
  border: solid 1px #666;
  background-color: #666;
}
</style>
